import React from "react";

export default ({
    children,
    title = "Missing Title",
    width = "1024px",
    height = "512px",
    author_avatar = "",
    author_name = "GoodSomm"
}) => {
    const styles = {
        width: width,
        height: height,
    };
    return (
        <div id="social-card" className="social-card" style={styles}>
      <div class="header"></div>
      <div class="title"><h1>{title}</h1></div>
      <div class="logo">
        <img src='https://goodsomm.com/assets/images/logos/horiz-white.png' class='GoodSomm' alt='GoodSomm' />
      </div>
      <div class="footer"></div>
    </div>
    );
};